
<script>
export default {
  props: {
    icon: String,
    text: String,
    color: String,
  },
}
</script>

<template>
  <Button class="pull-left push-10-r"
    :icon="icon"
    :color="color"
    :text="text"
    @click="$emit(`click`)"
  />
</template>